import { render, staticRenderFns } from "./InvoiceRowsReadOnlyPanel.vue?vue&type=template&id=52514088"
import script from "./InvoiceRowsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./InvoiceRowsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRowsReadOnlyPanel.vue?vue&type=style&index=0&id=52514088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports